/* 
    Dashboard URL pattern matching - example:
        - https://appmanager-dev.gfi.com/organization/3/dashboard/1153/instances/b8103ed9-b372-4c44-a5a3-b4514120ff3e/manage/configuration
        - https://appmanager.gfi.com/organization/3/dashboard/1153/instances/b8103ed9-b372-4c44-a5a3-b4514120ff3e/manage/configuration
*/
export const DASHBOARD_PATTERN = /^https?:\/\/[^/]+\/organization\/\d+\/dashboard\/\d+\/instances\/[^/]+\/manage\/configuration/;

/* 
    Organization ID pattern matching - example: extract the organization ID (id after /organization/) from the URL
        - https://appmanager-dev.gfi.com/organization/3
        - https://appmanager-dev.gfi.com/organization/3/dashboard
        - https://appmanager.gfi.com/organization/3/dashboard/1153/instances
        - https://appmanager.gfi.com/organization/3/any/path/here
        APPMNGRAI-329
*/

export const ORGANIZATION_ID_PATTERN = /\/organization\/(\d+)(?:\/|$)/;